import React, { useEffect, useState } from 'react';
import {
    Card, CardContent, Typography, Table, TableHead, TableRow,
    TableCell, TableBody, Button, makeStyles, TextField, TablePagination
} from '@material-ui/core';
import axios from 'axios';

const useStyles = makeStyles(() => ({
    card: {
        margin: '2rem auto',
        width: '95%',
        maxWidth: '1400px',
    },
    confirmed: { color: 'green', fontWeight: 'bold' },
    requested: { color: 'orange', fontWeight: 'bold' },
    rejected: { color: 'red', fontWeight: 'bold' },
    cancelled: { color: 'gray', fontWeight: 'bold' },
    sectionTitle: {
        marginTop: '2rem',
        textAlign: 'left'
    },
    tableHeaderCell: {
        fontWeight: 'bold',
        textAlign: 'left'
    },
    tableCell: {
        textAlign: 'center'
    },
    topBar: {
        marginBottom: '1rem',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
    },
    filterInput: {
        width: '300px'
    }
}));

const HolidayApproval = () => {
    const classes = useStyles();
    const [pendingHolidays, setPendingHolidays] = useState([]);
    const [allHolidays, setAllHolidays] = useState([]);
    const [error, setError] = useState('');
    const [filterText, setFilterText] = useState('');

    const [pendingPage, setPendingPage] = useState(0);
    const [allPage, setAllPage] = useState(0);
    const rowsPerPage = 15;

    const fetchPending = async () => {
        try {
            const res = await axios.get(`${process.env.REACT_APP_API_URL}/holidays/pending-with-names`);
            setPendingHolidays(res.data);
        } catch {
            setError('Error loading pending holidays');
        }
    };

    const fetchAllHolidays = async () => {
        try {
            const res = await axios.get(`${process.env.REACT_APP_API_URL}/holidays/all`);
            setAllHolidays(res.data);
        } catch {
            console.error('Error loading all holidays');
        }
    };

    useEffect(() => {
        fetchPending();
        fetchAllHolidays();
    }, []);

    const handleAction = async (id, action) => {
        try {
            await axios.post(`${process.env.REACT_APP_API_URL}/holidays/${action}/${id}`);
            fetchPending();
            fetchAllHolidays();
        } catch (err) {
            const message = err?.response?.data?.message || `Error when trying to ${action} holiday`;
            alert(message);
        }
    };

    const getStatusClass = (status) => {
        switch (status) {
            case 'CONFIRMADA': return classes.confirmed;
            case 'SOLICITADA': return classes.requested;
            case 'RECHAZADA': return classes.rejected;
            case 'CANCELADA': return classes.cancelled;
            default: return '';
        }
    };

    const filteredAllHolidays = allHolidays.filter(h =>
        h.employeeName.toLowerCase().includes(filterText.toLowerCase())
    );

    return (
        <>
            <Card className={classes.card}>
                <CardContent>
                    <Typography variant="h5" align="center" className={classes.sectionTitle}>Pending Holidays</Typography>
                    {error && <Typography color="error">{error}</Typography>}

                    {pendingHolidays.length === 0 ? (
                        <Typography align="center">No pending requests.</Typography>
                    ) : (
                        <>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell align="center" className={classes.tableHeaderCell}>Employee</TableCell>
                                        <TableCell align="center" className={classes.tableHeaderCell}>Date</TableCell>
                                        <TableCell align="center" className={classes.tableHeaderCell}>Status</TableCell>
                                        <TableCell align="center" className={classes.tableHeaderCell}>Actions</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {pendingHolidays
                                        .slice(pendingPage * rowsPerPage, (pendingPage + 1) * rowsPerPage)
                                        .map((h) => (
                                            <TableRow key={h.id}>
                                                <TableCell align="center" className={classes.tableCell}>{h.employeeName}</TableCell>
                                                <TableCell align="center" className={classes.tableCell}>{new Date(h.holidayDate).toLocaleDateString()}</TableCell>
                                                <TableCell align="center" className={`${classes.tableCell} ${getStatusClass(h.status)}`}>{h.status}</TableCell>
                                                <TableCell align="center" className={classes.tableCell}>
                                                    <Button
                                                        variant="contained"
                                                        color="primary"
                                                        size="small"
                                                        onClick={() => handleAction(h.id, 'confirm')}
                                                        style={{ marginRight: '8px' }}
                                                    >
                                                        Accept
                                                    </Button>
                                                    <Button
                                                        variant="contained"
                                                        color="secondary"
                                                        size="small"
                                                        onClick={() => handleAction(h.id, 'reject')}
                                                    >
                                                        Reject
                                                    </Button>
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                </TableBody>
                            </Table>
                            <TablePagination
                                component="div"
                                count={pendingHolidays.length}
                                page={pendingPage}
                                onPageChange={(e, newPage) => setPendingPage(newPage)}
                                rowsPerPage={rowsPerPage}
                                rowsPerPageOptions={[rowsPerPage]}
                            />
                        </>
                    )}
                </CardContent>
            </Card>

            <Card className={classes.card}>
                <CardContent>
                    <div className={classes.topBar}>
                        <Typography variant="h5" >
                            All Holidays
                        </Typography>
                        <TextField
                            label="Filter by employee"
                            variant="outlined"
                            className={classes.filterInput}
                            value={filterText}
                            onChange={(e) => {
                                setFilterText(e.target.value);
                                setAllPage(0);
                            }}
                        />
                    </div>

                    {filteredAllHolidays.length === 0 ? (
                        <Typography>No holidays found.</Typography>
                    ) : (
                        <>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Employee</TableCell>
                                        <TableCell>Date</TableCell>
                                        <TableCell>Status</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {filteredAllHolidays
                                        .slice(allPage * rowsPerPage, (allPage + 1) * rowsPerPage)
                                        .map((h) => (
                                            <TableRow key={h.id}>
                                                <TableCell  >{h.employeeName}</TableCell>
                                                <TableCell  >{new Date(h.holidayDate).toLocaleDateString()}</TableCell>
                                                <TableCell className={`${getStatusClass(h.status)}`}>{h.status}</TableCell>
                                            </TableRow>
                                        ))}
                                </TableBody>
                            </Table>
                            <TablePagination
                                component="div"
                                count={filteredAllHolidays.length}
                                page={allPage}
                                onPageChange={(e, newPage) => setAllPage(newPage)}
                                rowsPerPage={rowsPerPage}
                                rowsPerPageOptions={[rowsPerPage]}
                            />
                        </>
                    )}
                </CardContent>
            </Card>
        </>
    );
};

export default HolidayApproval;
